export default "__VITE_ASSET__f23bbf61__"